import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=71517b09&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71517b09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71517b09')) {
      api.createRecord('71517b09', component.options)
    } else {
      api.reload('71517b09', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=71517b09&scoped=true&", function () {
      api.rerender('71517b09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h84MOY71qHoH/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports